module.exports = __webpack_public_path__ + "img/UI_shouji_title_01_6b76befcd.png";